<template>
    <div class="flex">
        <div class="w-3/12 pr-4 border-r border-gray-300">
            <slot name="left" />
        </div>
        <div class="w-9/12 pl-4">
            <slot name="right" />
        </div>
    </div>
</template>
